import React from 'react';
import { warningsvg } from "../../assets/svg/svgimages";

const Input = ({ name, placeholder, value, onChange, errors }) => {
    const hasError = !!errors?.[name];

    // Логируем для отладки
    if (hasError) {
        console.log(`Ошибка в поле "${name}":`, errors[name]);
    }

    return (
        <>
            <input
                type="text"
                id={name}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className={`form-input ${hasError ? 'input-error' : ''}`}
            />
            {hasError && (
                <div className="error-message">
                    {warningsvg} {errors[name]}
                </div>
            )}
        </>
    );
};

export default Input;
